import { createSelector } from '@reduxjs/toolkit';
import { moduleNamespace } from '@Store/config.store';
import { NamespacedStoreState } from '@Types/store.types';
import { useSelector } from 'react-redux';

const parseNamespace = (state: NamespacedStoreState) => state[moduleNamespace];

const groupSetsStoreSelector = createSelector(parseNamespace, state => state.GroupSetsStore);

export const groupSetsListSelector = createSelector(
	groupSetsStoreSelector,
	groupSetsStore => groupSetsStore.groupSetsList,
);

export const selectGroupSets = () => useSelector(groupSetsListSelector);

export const groupSetSelector = createSelector(groupSetsStoreSelector, groupSetsStore => groupSetsStore.groupSet);

export const selectGroupSet = () => useSelector(groupSetSelector);
